import { Link } from 'react-router-dom';

import logo from '/images/RhymeLogo.png';

const Header = () => {
  return (
    <div className={'w-full pl-12 pt-4 hidden sm:flex'}>
      <Link to={'/'} className={'block'}>
        <img src={logo} width={84} height={38} />
      </Link>
    </div>
  );
};

export default Header;
